import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 24 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 19\" id=\"icon-mail\"><path d=\"M22.474 15.796L15.77 9.092l6.704-6.704zm-20.086.99l6.74-6.741 2.363 2.341a.7.7 0 00.986-.002l2.303-2.303 6.705 6.704zm-.99-.99V2.381L8.136 9.06zM21.486 1.4l-9.504 9.504L2.396 1.4zm.289-1.4H2.097A2.102 2.102 0 000 2.098v13.988a2.1 2.1 0 002.098 2.098h19.676a2.102 2.102 0 002.099-2.098V2.098A2.102 2.102 0 0021.774 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol